<div class="c-nav-panel">
  <div class="c-nav-panel__top">
    <div class="c-nav-panel__item">
      <div *ngIf="logo" class="c-nav-panel__logo">
        <img [src]="logo" />
      </div>
    </div>
  </div>

  <div class="c-nav-panel__bottom">
    <div class="c-nav-panel__button d-sm-none">
      <p500-ui-navbar-button
        icon="p500-ui-icon-dots-hor"
        [class.is-active]="sidebarService.isCurrent('menu')"
        (click)="openMenuSection('menu')"
      ></p500-ui-navbar-button>
    </div>
    <div class="c-nav-panel__button" *ngIf="!hideHelpMenu">
      <p500-ui-navbar-button
        icon="p500-ui-icon-question-circle"
        [class.is-active]="sidebarService.isCurrent('help')"
        (click)="openMenuSection('help')"
      >
        <gtd-help-menu *p500UINavbarButtonPopup cssClass="-box -floating"></gtd-help-menu>
      </p500-ui-navbar-button>
    </div>
    <div class="c-language-menu c-nav-panel__button">
      <p500-ui-navbar-button
        icon="p500-ui-icon-planet"
        [class.is-active]="sidebarService.isCurrent('language')"
        (click)="openMenuSection('language')"
      >
        <gtd-language-menu *p500UINavbarButtonPopup cssClass="-box -floating"></gtd-language-menu>
      </p500-ui-navbar-button>
    </div>
    <div class="c-nav-panel__button">
      <p500-ui-navbar-button
        icon="p500-ui-icon-user-fill"
        [class.is-active]="sidebarService.isCurrent('profile')"
        (click)="openMenuSection('profile')"
      >
        <gtd-profile-menu *p500UINavbarButtonPopup cssClass="-box -floating"></gtd-profile-menu>
      </p500-ui-navbar-button>
    </div>
  </div>
</div>
